import React, { useState, useEffect } from 'react'
import Modal from 'react-modal'
import AuthService from '../../../../services/auth'
import cutileiApi from '../../../../services/cutileiApi'
import Dashboard from '../../../../services/Dashboard'
import Comission from '../../../../services/Comission'
import PieChart from '../../../../components/Charts/PieChart'
import ColumnChart from '../../../../components/Charts/ColumnChart'
import Select from '../../../../components/Inputs/Select'
import { ReactComponent as Loading } from '../../../../icons/loading2.svg'
import * as FA from 'react-icons/fa'
import { DateTime } from 'luxon'

import {
  modalStyle,
  InfoContainer,
  ModalContainer,
  FilterContainer,
  CloseButton,
  SubTitle,
  LinkText
} from '../../styles'

function EarningsByProfessional ({
  data: earnings,
  professionals,
  selectedMonth = DateTime.now ().month,
  selectedYear = DateTime.now ().year
}) {
  const now = DateTime.now ()
  const token = AuthService.getToken ()
  const businessId = AuthService.getBusinessId ()

  const timeFilterOptions = [
    {label: '3 meses', value: 2},
    {label: '6 meses', value: 5},
    {label: '12 meses', value: 11},
    {label: 'Este ano', value: now.diff (now.startOf ('year'), 'months').months},
  ]

  const typeFilterOptions = [
    {label: 'Todos os rendimentos', value: 'all_earnings'},
    {label: 'Agendamentos Cutilei', value: 'cutilei'},
    {label: 'Comandas do salão', value: 'bill'}
  ]

  const [loading, setLoading] = useState (true)
  const [timeFilter, setTimeFilter] = useState (timeFilterOptions[0])
  const [typeFilter, setTypeFilter] = useState (typeFilterOptions[0])
  const [showDetails, setShowDetails] = useState (false)
  const [earningsByMonth, setEarningsByMonth] = useState ([])

  const earningsByProfessional = [
    ['Profissional', 'Valor (R$)'],
    ...professionals.map (professional => ([
      professional.nickname ?? professional.name.split (' ')[0],
      Comission.getTotalEarnings (earnings, {value: 'all_earnings'}, null, professional)
    ]))
  ]

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  useEffect (() => {
    getData ()
  }, [timeFilter, typeFilter])

  const getData = async () => {
    try {
      setLoading (true)

      const startDate = now.minus ({months: timeFilter.value}).startOf ('month').toISODate ()
      const endDate = now.toISODate ()
      const earnings = []

      const filters = `?business_id=${businessId}&order_by=created_at&order=asc&cutilei_schedules=true`
                  + '&detailed=true&open=false&status=validated&deleted=false&page=1&per_page=999999'
                  + `&start_date=${startDate}&end_date=${endDate}`

      if (['cutilei', 'all_earnings'].includes (typeFilter.value)) {
        const { data: schedules } = await cutileiApi.get (`/schedules${filters}`, requestConfig)
        earnings.push (...schedules.data.map (s => ({...s, type: 'cutilei'})))
      }

      if (['bill', 'all_earnings'].includes (typeFilter.value)) {
        const { data: bills } = await cutileiApi.get (`/business_bills${filters}`, requestConfig)
        earnings.push (...bills.map (b => ({...b, type: 'bill'})))
      }

      const earningsByMonth = Dashboard.groupEarningsByMonth (earnings)
      
      setEarningsByMonth ([
        ['Profissionais', ...professionals.map (professional => (
          professional.nickname ?? professional.name.split (' ')[0]
        ))],
        ...Object.keys (earningsByMonth).map (month => ([
          month,
          ...professionals.map (professional => (
            Comission.getTotalEarnings (earningsByMonth[month], {value: 'all_earnings'}, null, professional)
          ))
        ]))
      ])
    } catch (error) {
      console.log (error.response?.data)
    } finally {
      setLoading (false)
    }
  }

  const toggleDetails = () => setShowDetails (!showDetails)

  return (
    <InfoContainer>
      <SubTitle>Faturamento por profissional:</SubTitle>
      <PieChart data={earningsByProfessional}/>
      <LinkText onClick={toggleDetails}>
        Ver histórico
      </LinkText>
      <Modal
        isOpen={showDetails}
        onRequestClose={toggleDetails}
        shouldCloseOnOverlayClick={true}
        ariaHideApp={false}
        style={modalStyle}
      >
        <ModalContainer>
          <SubTitle>Faturamento por profissional</SubTitle>
          <CloseButton onClick={toggleDetails}>
            <FA.FaTimes color='#FF3939' size={18}/>
          </CloseButton>
          <FilterContainer style={{width: 520}}>
            <Select
              name='timeFilter'
              placeholder='Período...'
              value={timeFilter}
              options={timeFilterOptions}
              onChange={(_, option) => setTimeFilter (option)}
              containerStyles={{boxShadow: '0px 1px 10px -7px', borderRadius: 15}}
            />
            <Select
              name='scheduleType'
              placeholder='Tipo de agendamento...'
              value={typeFilter}
              options={typeFilterOptions}
              onChange={(_, option) => setTypeFilter (option)}
              containerStyles={{boxShadow: '0px 1px 10px -7px', borderRadius: 15}}
            />
          </FilterContainer>
          {loading ? (
            <Loading style={{marginBlock: 20, alignSelf: 'center'}}/>
          ) : (
            <ColumnChart
              data={earningsByMonth}
              options={{
                chartArea: {
                  width: '68%',
                  left: 125
                }
              }}
            />
          )}
        </ModalContainer>
      </Modal>
    </InfoContainer>
  )
}

export default EarningsByProfessional
